import * as yup from "yup"

const MESSAGES = {
  lengthContinuity:
    "The min length must be equal to the max length of the previous rate",
  maxLengthGreaterThanMin: "Max length must be greater than min length",
  atLeastOneRateRequired: "at least 1 rate is required",
  atLeastOneMinLengthZero: "At least 1 min length must start at 0",
  required: "This field is required.",
  numberMsg: "Amount must be a number.",
  nameMsg: "Name is required.",
  rateTypeMsg: "Rate type is required.",
  min0Msg: "Amount must be greater than 0.",
  thresholdIntegerMsg: "Threshold must be a whole number.",
  maxLengthMsg: "Length must be at most 2,000 feet.",
}

export const schema = yup
  .object()
  .shape({
    rateThresholds: yup.array().of(
      yup.array().of(
        yup.object().shape({
          rate: yup
            .number()
            .typeError(MESSAGES.numberMsg)
            .required(MESSAGES.required)
            .min(0, MESSAGES.min0Msg),
        })
      )
    ),
    thresholds: yup
      .array()
      .of(
        yup
          .number()
          .typeError(MESSAGES.numberMsg)
          .required(MESSAGES.required)
          .integer(MESSAGES.thresholdIntegerMsg)
          .min(0, MESSAGES.min0Msg)
      ),
    rateStrategy: yup.object().shape({
      name: yup
        .string()
        .typeError(MESSAGES.nameMsg)
        .required(MESSAGES.required),
      rateType: yup
        .string()
        .typeError(MESSAGES.rateTypeMsg)
        .required(MESSAGES.required),
      advancedPricing: yup.boolean().required(MESSAGES.required),
      rates: yup
        .array()
        .of(
          yup
            .object()
            .shape({
              minLength: yup
                .number()
                .typeError(MESSAGES.numberMsg)
                .required(MESSAGES.required)
                .min(0, MESSAGES.min0Msg)
                .max(2000, MESSAGES.maxLengthMsg)
                .test(
                  "length continuity",
                  MESSAGES.lengthContinuity,
                  (value, context) => {
                    const { from, path } = context
                    const parentRates = from?.[1]?.value?.rates
                    const index = parseInt(path.match(/\[(\d+)\]/)[1])
                    if (parentRates && index > 0) {
                      return (
                        parseInt(value) ===
                        parseInt(parentRates[index - 1].maxLength)
                      )
                    }
                    return true
                  }
                ),
              maxLength: yup
                .number()
                .typeError(MESSAGES.numberMsg)
                .required(MESSAGES.required)
                .min(0, MESSAGES.min0Msg)
                .max(2000, MESSAGES.maxLengthMsg)
                .when("minLength", (minLength) => {
                  if (minLength) {
                    return yup
                      .number()
                      .typeError(MESSAGES.numberMsg)
                      .min(minLength, MESSAGES.maxLengthGreaterThanMin)
                      .max(2000, MESSAGES.maxLengthMsg)
                  }
                }),
              rate: yup
                .number()
                .typeError(MESSAGES.numberMsg)
                .required(MESSAGES.required)
                .min(0, MESSAGES.min0Msg),
            })
            .required(MESSAGES.required)
        )
        .min(1, MESSAGES.atLeastOneRateRequired)
        .required(MESSAGES.required)
        .test(
          "at least one minLength zero",
          MESSAGES.atLeastOneMinLengthZero,
          (rates) => rates.some((rate) => rate.minLength === 0)
        ),
    }),
  })
  .required()

export default schema
